<template>
  <div class="location-selector">
    <div :class="['location-container', 'pointer', disabled ? 'disabled' : '']" @click="open">
      <div v-if="!value" class="empty">
        <input
          class="el-input__inner pointer"
          type="text"
          autocomplete="off"
          placeholder="请选择"
          disabled
        />
        <i class="el-icon-location"></i>
      </div>
      <div v-else class="address-card">
        <div v-if="value.poiName" class="title">{{ value.poiName }}</div>
        <div class="detail" v-tip>{{ value.address }}</div>
        <span v-if="!disabled" class="icon-delete" @click.stop="emitVal(null)">
          <svg-icon icon-class="svgo_close-round"></svg-icon>
        </span>
      </div>
    </div>
    <location-dialog
      ref="locationDialog"
      :scope="scope"
      :value="value"
      @input="emitVal"
    ></location-dialog>
  </div>
</template>

<script>
import LocationDialog from "@/components/UIComponents/LocationDialog.vue"
import { searchLocation } from "@/utils/location"
export default {
  name: "location-selector",
  components: {
    LocationDialog
  },
  props: {
    value: Object,
    disabled: Boolean,
    control: Object,
    form: Object
  },
  data() {
    return {
      scope: null
    }
  },
  created() {
    this.listenScopeChange()
  },
  methods: {
    listenScopeChange() {
      if (!this.control.range) return
      let { type, value, location, level, radius } = this.control.range
      // 固定定位
      if (type === "const" && location) {
        this.scope = { lng: location.lng, lat: location.lat, radius }
        return
      }
      // 当前定位
      if (value === "vCurrentLocation") {
        location = this.$store.getters.location
        if (!this._.isEmpty(location)) {
          this.scope = { lng: location.lng, lat: location.lat, radius }
        }
        return
      }
      // 根据其他控件计算
      if (["area", "location"].includes(type) && value) {
        this.$watch("form." + value.slice(1), async function(newVal) {
          if (this._.isEmpty(newVal)) return
          if (type === "location") {
            this.scope = { lng: newVal.lng, lat: newVal.lat, radius }
          } else if (type === "area") {
            let addr0 = newVal[0].split("-")
            if (level) {
              addr0 = addr0.slice(0, level)
              addr0[0] += "省"
            }
            addr0 = addr0.join() + "政府"
            let location = await searchLocation(addr0)
            if (location) {
              this.scope = { lng: location.lng, lat: location.lat, radius }
            }
          }
        })
      }
    },
    emitVal(val) {
      this.$emit("input", val)
    },
    open() {
      if (!this.disabled) {
        this.$refs.locationDialog.open()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.location-selector {
  .location-container {
    min-height: 30px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    overflow: hidden;
    &:hover {
      border: 1px solid #c0c4cc;
    }
    &.disabled {
      &:hover {
        border: 1px solid #dcdfe6;
      }
      .empty,
      .address-card {
        background: #f5f7fa;
      }
      .el-input__inner {
        z-index: 0 !important;
      }
    }
    .empty {
      display: flex;
      align-items: center;
      padding: 0 9px 0 15px;
      position: relative;
      height: 32px;
      .el-input__inner {
        border: none;
        line-height: unset;
        height: unset;
        background: unset;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
      }
      .el-icon-location {
        margin-left: auto;
        color: #c0c4cc;
      }
    }
    .address-card {
      padding: 5px 15px;
      line-height: 22px;
      color: #303133;
      border: none;
      ::v-deep .el-card__body {
        padding: 5px;
      }
      .title {
        font-size: 14px;
        font-weight: bold;
      }
      .detail {
        font-size: 12px;
      }
      &:hover {
        .icon-delete {
          visibility: visible;
        }
      }
      .icon-delete {
        visibility: hidden;
        position: absolute;
        padding: 4px;
        right: 0;
        top: 0;
        cursor: pointer;
        font-size: 18px;
        color: #bdbdbd;
        &:hover {
          color: #1e88e5;
        }
      }
    }
  }
}
</style>
